import React  from 'react';
export default function PlanificacionPei(){

    return (
        <>
            <h1>PEI Planificacion</h1>
        </>
    );
}